import api from "../api"

export const actionplanAPI={
	async getAll(MatrixID){
		let value = await api.get(`/actionplan/`, { params: { MatrixID: MatrixID } })
		//new line is here 
		// to chech the which line has the issue
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async createAction(MatrixID, Mitigation, Description, Connection_to_risk, Status, Assigned, Created, ExpiryDate){
		let value = await api.post(`/actionplan/`,{
			MatrixID:MatrixID,
			Mitigation: Mitigation,
			Description: Description,
			Connection_to_risk: Connection_to_risk,
			Status: Status,
			Assigned: Assigned,
			Created: Created,
			ExpiryDate: ExpiryDate,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async deleteAction(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.delete(`/actionplan/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	},
	async getActionById(ID){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.get(`/actionplan/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async updateActionById(ID, Mitigation, Description, Connection_to_risk, Status, Assigned, Created, ExpiryDate){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.put(`/actionplan/${ID}`,{
			Mitigation: Mitigation,
			Description: Description,
			Connection_to_risk: Connection_to_risk,
			Status: Status,
			Assigned: Assigned,
			Created: Created,
			ExpiryDate: ExpiryDate,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async approveActionPlan(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/actionplanapprove`, { id: ID })
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
}